<div class="table-container">
  <ng-container *ngIf="loading">
    <app-loading></app-loading>
  </ng-container>

  <ng-container *ngIf="!loading">
    <ng-content *ngIf="!loading && items.length"></ng-content>
  </ng-container>

  <ng-container *ngIf="!loading && !totalRows">
    <p>Nenhum registro encontrado</p>
  </ng-container>

  <mat-paginator
    [length]="totalRows"
    [pageSize]="10"
    (page)="pageChange.emit($event.pageIndex + 1)"
  >
  </mat-paginator>
</div>
